import { lazy, Suspense } from "react";
import { useMaintenanceMode } from "@/hooks/useMaintenanceMode";
import ComingSoon from "./ComingSoon";

const LandingPage = lazy(() => import("./LandingPage"));

const DashboardLoading = () => (
  <div className="min-h-screen flex items-center justify-center bg-black">
    <div className="w-8 h-8 border-2 border-blue-500 border-t-transparent rounded-full animate-spin" />
  </div>
);

const Index = () => {
  const { isMaintenanceMode, isLoading } = useMaintenanceMode();

  // Default is maintenance mode, so render ComingSoon immediately (no loading spinner)
  // This ensures FCP happens instantly without waiting for the Supabase query
  if (isMaintenanceMode) return <ComingSoon />;

  if (isLoading) return <DashboardLoading />;

  return (
    <Suspense fallback={<DashboardLoading />}>
      <LandingPage />
    </Suspense>
  );
};

export default Index;
